import _environmentUserAgent from "../internals/environment-user-agent";
var exports = {};
var userAgent = _environmentUserAgent;
var firefox = userAgent.match(/firefox\/(\d+)/i);
exports = !!firefox && +firefox[1];
export default exports;